import React from "react";
import { Box, Typography } from "@mui/material";
import { tokens } from "./tokens";

/**
 * Estado vacío útil (§6): mensaje + acción opcional. Nunca un spinner gigante.
 */
export default function ClinicalEmptyState({ message, action, sx }) {
  return (
    <Box sx={{ textAlign: "center", py: 3, ...sx }}>
      <Typography sx={{ fontSize: 13.5, color: tokens.ink3, mb: action ? 1.5 : 0 }}>
        {message}
      </Typography>
      {action}
    </Box>
  );
}
